import { createSelector } from 'reselect';

export const selectLocalization = state => state.localization;

export const selectLocale = createSelector(
    [selectLocalization],
    localization => localization.locale,
);
